import {Subject, BehaviorSubject, combineLatest} from 'rxjs';
import {map, shareReplay} from 'rxjs/operators';
import {spotsMap$, contractMap$, currenciesInfoMap$, marginsMap$} from '@px/streams/config';
import {spotMarketCache$} from '@px/streams/market-spot';
import {contractMarketCache$} from '@px/streams/market-contract';

export const closeMarketSelectPopup$ = new Subject<void>();
export const marketSelectVisible$ = new BehaviorSubject<boolean>(false);
export const marketTopDis$ = new BehaviorSubject(0);
export const announcementTopDis$ = new BehaviorSubject(0);

export const contractMarkets$ = combineLatest([contractMarketCache$, contractMap$]).pipe(
  map(([marketsCache, contractMap]) => {
    const markets = [...marketsCache.values()];
    return markets
      .filter(({status}) => checkTradePairVisible(status))
      .map((market) => {
        const contract = contractMap.get(market.symbol);
        const {settleCurrency, quoteCurrency, timeline, categoryIds} = contract;
        const deadline = 86400000 * 30;
        const isNew = Date.now() < deadline + timeline[1];
        return {
          ...market,
          settleCurrency,
          quoteCurrency,
          timeline,
          categoryIds,
          isNew,
        };
      });
  }),
  shareReplay(1)
);

export const spotMarkets$ = combineLatest([spotMarketCache$, spotsMap$, currenciesInfoMap$]).pipe(
  map(([marketsCache, spotsCache, currenciesInfoMap]) => {
    const markets = [...marketsCache.values()];
    return markets
      .filter(({status}) => checkTradePairVisible(status))
      .map((market) => {
        const spot = spotsCache.get(market.symbol);
        const {type, symbol, displayBaseCurrency, displaySymbol, name, pricePrecision, baseCurrency, status, timeline, categoryIds} = spot;
        const deadline = 86400000 * 30;
        const isNew = Date.now() < deadline + timeline[1];
        const info = currenciesInfoMap.get(baseCurrency);
        return {
          ...market,
          type,
          symbol,
          pairName: displaySymbol,
          displaySymbol,
          baseCurrency,
          displayBaseCurrency,
          name: info?.fullName || '-',
          status,
          timeline,
          categoryIds,
          isNew,
        };
      });
  }),
  shareReplay(1)
);

export const marginMarkets$ = combineLatest([spotMarkets$, marginsMap$]).pipe(
  map(([spotMarkets, marginsMap]) => spotMarkets.filter((market) => [...marginsMap.keys()].includes(market.symbol))),
  shareReplay(1)
);

export function checkTradePairVisible(status) {
  return ['Listed', 'PreList', 'Suspend', 'Delisted'].includes(status);
}
